var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img-placeholder_svg__clip0)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 19.5H.75V3.75h16.5l6 6v9.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9.75h-6v-6M6 9.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3.75 16.5c0-.787 1.875-4.5 3.75-4.5s1.5 1.5 2.25 1.5.938-4.5 3-4.5c2.063 0 4.5 6.863 4.5 7.5H3.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img-placeholder_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "#fff"
  })))));
}

export default SvgImgPlaceholder;